import { render, staticRenderFns } from "./MassiveAnnex.vue?vue&type=template&id=c4819ca8"
import script from "./MassiveAnnex.vue?vue&type=script&lang=js"
export * from "./MassiveAnnex.vue?vue&type=script&lang=js"
import style0 from "./MassiveAnnex.vue?vue&type=style&index=0&id=c4819ca8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports